<template lang="pug">
section
  s-page-title(title='Рабочий стол')
  //- Просто пользователь
  //- user(v-if='$user.hasRoles([userRoles.User, userRoles.Admin])')

  //- Клиент
  client(v-if='$user.hasRoles([userRoles.Client, userRoles.Admin])')

  //- Менеджер
  manager(v-if='$user.hasRoles([userRoles.Manager, userRoles.Admin])')

  //- Контакт-центр, менеджер расписания
  schedule(v-if='$user.hasRoles([userRoles.ScheduleManager, userRoles.Admin])')

  //- менеджер на объекте
  scheduleList(v-if='$user.hasRoles([userRoles.ObjectManager, userRoles.Admin])')

</template>

<script>
import User from './workspace/User'
import Client from './workspace/Client'
import Manager from './workspace/Manager'
import Schedule from './workspace/Schedule'
import ScheduleList from './workspace/ScheduleList'

import { userRoles } from '@/enums/user-roles'

export default {
  components: {
    User,
    Client,
    Manager,
    Schedule,
    ScheduleList
  },

  data: () => ({
    userRoles
  })
}
</script>
